import { queryOptions, useQuery } from '@tanstack/react-query'

import { getMe } from '@/shared/api/usersSharedApi'
import { useAuthStore } from '@/shared/auth/stores/authStore'

// Self-profile fetch via GET /users/me. Only fires once we have an
// authenticated session (no point asking for "me" before login). 5-min
// staleTime — own profile rarely changes mid-session, and we invalidate
// on relevant mutations (role change, deactivation) elsewhere.
export function meQueryOptions() {
  return queryOptions({
    queryKey: ['users', 'me'] as const,
    queryFn: getMe,
    staleTime: 5 * 60 * 1000,
  })
}

export function useGetMe() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return useQuery({
    ...meQueryOptions(),
    enabled: isAuthenticated,
  })
}
